var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-login"},[_c('i',{staticClass:"fas fa-arrow-left",on:{"click":function($event){return _vm.$router.go(-1)}}}),_c('router-link',{attrs:{"to":"/"}},[_c('i',{staticClass:"fas fa-times"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }